import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Page, Pageable, RestClientPaged } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { FilterBuilder } from '../../orders/filter-builder'
import { CapabilitySpec } from './capabilities/capability-spec'

@Injectable({
  providedIn: 'root',
})
export class CapabilitySpecService extends RestClientPaged<CapabilitySpec, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/capability-specs', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public findAllById(ids: string[]): Observable<Page<CapabilitySpec>> {
    return this.findAllPaged(new Pageable(0, 100), [FilterBuilder.ids(ids)])
  }
}
